import { HStack, Stack, Text } from "@chakra-ui/react";
import { IconCheck, IconDot } from "~/components/icons.tsx";
import { t, T } from "~/libs/i18n";

export function PasswordPolicyChecks({ password }: { password: string }) {
  const LineItem = ({
    requirement,
    met,
    itemId,
  }: {
    requirement: string;
    met: boolean;
    itemId: string;
  }) => (
    <HStack
      pl={3}
      textColor={met ? "green.500" : "inherit"}
      data-testid={itemId}
    >
      {met ? (
        <IconCheck boxSize={3} data-testid={"icon-check"} />
      ) : (
        <IconDot boxSize={3} data-testid={"icon-dot"} />
      )}
      <Text textStyle={"small"}>{requirement}</Text>
    </HStack>
  );
  return (
    <Stack layerStyle={"muted"}>
      <Text textStyle={"small"}>
        <T>Your password must have at least</T>
      </Text>
      <LineItem
        requirement="8 characters"
        met={password.length >= 8}
        itemId={"8char"}
      />
      <LineItem
        requirement={t("one lowercase letter")}
        met={/[a-z]/.test(password)}
        itemId={"lowercase"}
      />
      <LineItem
        requirement={t("one uppercase letter")}
        met={/[A-Z]/.test(password)}
        itemId={"uppercase"}
      />
      <LineItem
        requirement={t("one number")}
        met={/[0-9]/.test(password)}
        itemId={"number"}
      />
      <LineItem
        requirement={t("one special character")}
        // eslint-disable-next-line no-useless-escape
        met={/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password)}
        itemId={"special"}
      />
    </Stack>
  );
}
